// extracted by mini-css-extract-plugin
module.exports = {"container":"RegisterStyle_container__2PqMV","form":"RegisterStyle_form__3XemE","LinkS":"RegisterStyle_LinkS__oEdrh","span":"RegisterStyle_span__33tAy","p":"RegisterStyle_p__1Gxjl"};